/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerBlogNotAvailable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m19.586 21 .707.707 1.414-1.414-19-19-1.414 1.414.707.707V21zm-2-2H4V5.414l2 2V13h5.586l2 2H6v2h9.586zM8 9.414 9.586 11H8zM17.243 13 16 11.757V11h2v2zM20 15.757l2 2V3H7.243l2 2H20zM14 9h4V7h-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomerBlogNotAvailable as CustomerBlogNotAvailable };
